import { ListItem, ListItemAvatar, ListItemText } from "@material-ui/core";
import Divider from "@material-ui/core/Divider";
import Icon from "@material-ui/core/Icon";
import { withStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import React, { Component } from "react";

const styles = (theme) => ({
  hoverNoti: {
    "&:hover": {
      backgroundColor: "rgba(0, 0, 0, 0.04)",
    },
  },
});

class ListNotification extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { classes, index, item, subContent, icon } = this.props;

    return (
      <React.Fragment key={index}>
        <ListItem
          style={{ backgroundColor: this.props.isRead ? "" : "#ecf0f1" }}
          onClick={() => this.props.onSelectedItem(item)}
          autoFocus={true}
          className={classes.hoverNoti}>
          <ListItemAvatar>
            <Icon>{icon}</Icon>
          </ListItemAvatar>
          <ListItemText
            primary={`${
              this.props.isRead ? item.title : item.title + " (chưa đọc)"
            }`}
            secondary={subContent}
          />
          {/*<ListItemSecondaryAction>*/}
          {/*    <IconButton aria-label="call" >*/}
          {/*        <Icon>call</Icon>*/}
          {/*    </IconButton>*/}
          {/*</ListItemSecondaryAction>*/}
        </ListItem>
        {index >= 0 ? <Divider /> : null}
        {/*<ListItem>*/}
        {/*    Xem thêm*/}
        {/*</ListItem>*/}
      </React.Fragment>
    );
  }
}

ListNotification.propTypes = {
  icon: PropTypes.string,
  item: PropTypes.object,
  index: PropTypes.number,
  subContent: PropTypes.element,
  onSelectedItem: PropTypes.func,
};

ListNotification.defaultProps = {};

export default withStyles(styles)(ListNotification);
